import {BaseContainerModel} from '../../base-container.model';
import {
  bl_fi_mst_entity_merging_processing_RowClass,
  bl_fi_mst_entity_merging_processing_RowInterface
} from '../../../dbschema/index';

export class EntityMergingProcessingContainerModel extends BaseContainerModel {
  bl_fi_mst_entity_merging_processing: bl_fi_mst_entity_merging_processing_RowInterface = new bl_fi_mst_entity_merging_processing_RowClass();
}
